import React, { lazy } from 'react';

const UserListing = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/AccessSecurityModule/UserModule/UserListing'
  ).then(module => ({
    default: module.UserListing,
  })),
);
const UserDetail = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/AccessSecurityModule/UserModule/UserDetail'
  ).then(module => ({
    default: module.UserDetail,
  })),
);

const UserForm = lazy(() =>
  import(
    '@contract-root/admin-react/src/containers/SystemAdminModule/AccessSecurityModule/UserModule/UserForm'
  ).then(module => ({
    default: module.UserForm,
  })),
);

export const userRoutes = [
  //USERLIST
  {
    props: {
      exact: true,
      path: '/access-security/user',
    },
    component: <UserListing software="Site" />,
  },
  //USER Detail
  {
    props: {
      exact: true,
      path: '/access-security/user/detail/:userID',
    },
    component: <UserDetail software="Site" />,
  },

  {
    props: {
      exact: true,
      path: '/access-security/user/add',
    },
    component: <UserForm mode={'add'} software="Site" />,
  },

  {
    props: {
      exact: true,
      path: '/access-security/user/edit/:userID',
    },
    component: <UserForm mode={'edit'} software="Site" />,
  },
];
